import { useEffect, useState } from 'react';
import { consoleApi } from './admin-console';
import type { FundsCapabilities } from './admin-presentation';

export function useFundsCapabilities(enabled = true) {
  const [capabilities, setCapabilities] = useState<FundsCapabilities>();
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setCapabilities(undefined); setError('');
    void consoleApi<FundsCapabilities>('/v1/admin/funds/capabilities', { signal: controller.signal })
      .then(value => { if (!controller.signal.aborted) setCapabilities(value); })
      .catch(() => { if (!controller.signal.aborted) setError('无法确认资金通道状态，暂不可审批出款或退款。'); });
    return () => controller.abort();
  }, [enabled, revision]);
  return { capabilities, error, retry: () => setRevision(value => value + 1) };
}
